/**
 * Root Redux-Saga.
 *
 * Composes all feature sagas into a single root saga that is passed to
 * `sagaMiddleware.run()` in the store configuration.  Currently manages:
 * - `websocketWatcher` — processes live tick batches from the WebSocket.
 * - `metadataWatcher`  — dispatches metadata after the login flow.
 */
import { all } from "redux-saga/effects";

import { websocketWatcher } from "./websocket-middleware";
import { metadataWatcher } from "./metadata-middleware";

export function* rootSaga() {
  yield all([websocketWatcher(), metadataWatcher()]);
}
